import React, { useState, useRef } from 'react';
import { Employee } from '../types';

interface Props {
  onClose: () => void;
  onSave: (emp: Omit<Employee, 'id'> | Employee) => void;
  initialData?: Employee;
}

const AddEmployeeModal: React.FC<Props> = ({ onClose, onSave, initialData }) => {
  const [form, setForm] = useState<Omit<Employee, 'id'>>(
    initialData || {
      fullName: '',
      position: '',
      passNumber: '',
      expirationDate: '',
    }
  );

  const [errors, setErrors] = useState({
    fullName: false,
    position: false,
    passNumber: false,
    expirationDate: false
  });

  const fullNameRef = useRef<HTMLInputElement>(null);
  const positionRef = useRef<HTMLSelectElement>(null);
  const passNumberRef = useRef<HTMLInputElement>(null);
  const dateRef = useRef<HTMLInputElement>(null);

  const handleChange = (field: keyof Employee, value: string) => {
    setForm(prev => ({ ...prev, [field]: value }));
    setErrors(prev => ({ ...prev, [field]: false }));
  };

  const handleSubmit = () => {
    const newErrors = {
      fullName: !form.fullName,
      position: !form.position,
      passNumber: !form.passNumber,
      expirationDate: !form.expirationDate
    };
    setErrors(newErrors);

    if (newErrors.fullName) fullNameRef.current?.focus();
    else if (newErrors.position) positionRef.current?.focus();
    else if (newErrors.passNumber) passNumberRef.current?.focus();
    else if (newErrors.expirationDate) dateRef.current?.focus();

    if (!Object.values(newErrors).some(Boolean)) {
      onSave(form);
    }
  };

  const isEditing = Boolean(initialData);

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2 style={{ marginBottom: '16px', fontSize: '18px', textAlign: 'center' }}>
          {isEditing ? 'Редактировать сотрудника' : 'Добавить сотрудника'}
        </h2>

        <div>
          {errors.fullName && <div className="form-error-above">Заполните ФИО</div>}
          <input
            ref={fullNameRef}
            placeholder="ФИО"
            value={form.fullName}
            onChange={(e) => handleChange('fullName', e.target.value)}
          />
        </div>

        <div>
          {errors.position && <div className="form-error-above">Выберите должность</div>}
          <select
            ref={positionRef}
            value={form.position}
            onChange={(e) => handleChange('position', e.target.value)}
          >
            <option value="">Выберите должность</option>
            <option value="Начальник АДЦ">Начальник АДЦ</option>
            <option value="Зам. начальника АДЦ">Зам. начальника АДЦ</option>
            <option value="Диспетчер-инструктор АДЦ">Диспетчер-инструктор АДЦ</option>
            <option value="Специалист ОМО">Специалист ОМО</option>
            <option value="РП АДЦ">РП АДЦ</option>
            <option value="Старший диспетчер АДЦ">Старший диспетчер АДЦ</option>
            <option value="Диспетчер ОН УВД АДЦ">Диспетчер ОН УВД АДЦ</option>
          </select>
        </div>

        <div>
          {errors.passNumber && <div className="form-error-above">Введите номер пропуска</div>}
          <input
            ref={passNumberRef}
            placeholder="Номер пропуска"
            value={form.passNumber}
            onChange={(e) => handleChange('passNumber', e.target.value)}
          />
        </div>

        <div>
        <label style={{ fontSize: '12px', marginBottom: '4px', display: 'block' }}>
      Дата окончания пропуска
  </label>
  {errors.expirationDate && <div className="form-error-above">Укажите дату окончания</div>}
  <input
    ref={dateRef}
    type="date"
    value={form.expirationDate}
    onChange={(e) => handleChange('expirationDate', e.target.value)}
  />
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', marginTop: '16px', gap: '10px' }}>
          <button onClick={handleSubmit} style={{ flex: 1 }}>Сохранить</button>
          <button onClick={onClose} style={{ flex: 1}} className="secondary-btn">Отмена</button>
        </div>
      </div>
    </div>
  );
};

export default AddEmployeeModal;
